// DUCKS pattern
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { PhoneNumberModel } from "./estimateSlice";

export interface CallbackModel {
  name?: string;
  phoneNumber?: PhoneNumberModel;
  preferredDate: string;
  preferredTime: string;
  notARobot: boolean;
}

export interface CallbackState {
  data: CallbackModel;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: CallbackState = {
  data: { preferredDate: "", preferredTime: "", notARobot: false },
  status: "idle",
  error: null,
};

const callbackSlice = createSlice({
  name: "callback",
  initialState,
  reducers: {
    changeDate(state, action: PayloadAction<string>) {
      state.data.preferredDate = action.payload;
    },
    changeTime(state, action: PayloadAction<string>) {
      state.data.preferredTime = action.payload;
    },
    changeNotARobot(state, action: PayloadAction<boolean>) {
      state.data.notARobot = action.payload;
    },
  },
});

export const { changeDate, changeTime, changeNotARobot } =
  callbackSlice.actions;
export default callbackSlice.reducer;

export const selectCallback = (state: RootState) => state.callback.data;
export const selectCallbackStatus = (state: RootState) => state.callback.status;
